import { BaseModel } from "./base.model";
import { Budget } from "./budget.model";

export class Consultant extends BaseModel {

    constructor(
        public name?: string,
        public initials?: string,
        public departmentId?: string,
        public email?: string,
        public dashboardAccess?: boolean,
        public includedInDashboard?: boolean,
        public budgetPersonalSales?: Budget[],
        public budgetTotalSales?: Budget[],
        public salaries?: ConsultantSalary[],
    ) {
        super();

    }
}

export enum Position {
    None,
    Ledelseskonsulent,
    Chefkonsulent,
    Partner
}

export const POSITION_DEFAULTS: Record<Position, number> = {
    [Position.None]: 0,
    [Position.Ledelseskonsulent]: 10,
    [Position.Chefkonsulent]: 48,
    [Position.Partner]: 55,
};

export const POSITION_LABELS: Record<Position, string> = {
    [Position.None]: 'Ingen',
    [Position.Ledelseskonsulent]: 'Ledelseskonsulent',
    [Position.Chefkonsulent]: 'Chefkonsulent',
    [Position.Partner]: 'Partner',
};

export class ConsultantSalary extends BaseModel {
    constructor(
        public consultantId?: string,
        public year?: number,
        public monthlySalary?: number,
        public monthlySharedExpenses?: number,
        public position?: Position,
        public bonusPercentage?: number,
    ) {
        super();
    }
}

export class SalesRealizatorAmount extends BaseModel {
    constructor(
        public consultantId?: string,
        public orderId?: string,
        public amount?: number
    ) {
        super();
    }
}

export class ExecutorAmount extends BaseModel {
    constructor(
        public consultantId?: string,
        public orderId?: string,
        public amount?: number,
    ) {
        super();
    }
}

export class DistributionAmount extends BaseModel {
    constructor(
        public consultantId?: string,
        public orderId?: string,
        public amount?: number,
        public feeBasis?: number,
        public invoiceId?: string,
        public invoiceId1?: string,
        public invoiceId2?: string,
    ) {
        super();
    }
}